import { GrowthBook } from "@growthbook/growthbook";
import { captureException } from "@sentry/vue";
import axios from "axios";
import config from "../config";
import { useQuoteStore } from "@/stores/quotes";
import { getSessionId } from "@/utils";
import { InjectionKey } from "vue";

const gbInstance = new GrowthBook({
    apiHost: `${config.growthBookApiHost}`,
    clientKey: config.growthBookClientKey,
    trackingCallback: async (experiment, result) => {
        try {
            await axios.post(
                `${config.quoteApiUrl}/v1/split-tests/session-assignments`,
                {
                    sessionId: result.hashValue,
                    product: "annuities",
                    experimentId: experiment.key,
                    variationId: result.variationId,
                },
            );
        } catch (error) {
            captureException(error);
        }
    },
});

export const gbKey = Symbol("gb") as InjectionKey<typeof gbInstance | null>;

export const initializeGrowthBook = async () : Promise<GrowthBook | null> => {
    if (!config.growthBookApiHost || !config.growthBookClientKey) {
        return null;
    }

    const quoteStore = useQuoteStore();
    const affiliate = quoteStore.getAffiliate();

    try {
        gbInstance.setAttributes({
            session_id: getSessionId(),
            affiliate: affiliate.name,
            source: affiliate.source,
            userAgent: navigator.userAgent,
            host: window.location.hostname,
            path: window.location.pathname,
            product: "annuities",
        });

        await gbInstance.init();

        return gbInstance;
    } catch (err) {
        captureException(err);
        return null;
    }
};
